import { AuthenticationService } from '../../authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomAlertService } from '../../custom-alert/custom-alert.service';
import { resolve } from 'dns';

@Injectable({
  providedIn: 'root'
})

export class OperacaoVazaoService {

  constructor(
    private httpClient: HttpClient,
    private authService: AuthenticationService,
    private alert: CustomAlertService,
  ) { }

  async getVazoes(id_operacao: string, tipo: 'O' | 'D', id_loteSelecionado: number): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.API_ENDPOINT.apiOperacoesVazao, {
        params: {
          "id_usuario": user.idUsuario.toString(),
          "id_empresa": user.idEmpresa.toString(),
          "id_operacao": id_operacao,
          "id_loteSelecionado": id_loteSelecionado.toString()
        }
      })
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  async addOperacaoVazao(operacaoVazao: AddOperacaoVazao): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    operacaoVazao.id_usuario = user.idUsuario;
    operacaoVazao.id_empresa = user.idEmpresa;

    return new Promise((resolve, reject) => {
      this.httpClient.post(environment.API_ENDPOINT.apiOperacoesVazao, operacaoVazao)
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    })
  }

  async addOperacaoObs(operacaoVazao: AddOperacaoVazao): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    operacaoVazao.id_usuario = user.idUsuario;
    operacaoVazao.id_empresa = user.idEmpresa;

    return new Promise((resolve, reject) => {
      this.httpClient.post(environment.API_ENDPOINT.apiOperacoesVazao + "/observacao", operacaoVazao)
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    })
  }

  async editOperacaoVazao(dados: any): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    let body = {
      ...dados,
      id_usuario: user.idUsuario,
      id_empresa: user.idEmpresa,
    }
    return new Promise((resolve, reject) => {
      this.httpClient.put(environment.API_ENDPOINT.apiOperacoesVazao, body)
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    })
  }

  async deleteOperacaoVazao(dados: any): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    let customParams = {
      id_usuario: user.idUsuario,
      id_empresa: user.idEmpresa,
      id_operacaoVazao: dados.id_operacaoVazao
    }
    return new Promise((resolve, reject) => {
      this.httpClient.delete(environment.API_ENDPOINT.apiOperacoesVazao, {
        params: {
          ...customParams
        }
      })
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    })
    
  }

  async saveStrippingTime(id_operacao,id_operacaoLote,stripping): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    let body = {
      id_empresa: user.idEmpresa,
      id_usuario: user.idUsuario,
      id_operacao: id_operacao,
      id_lote: id_operacaoLote,
      strippingTimeBegin: this.mkTimeNow(stripping.begin),
      strippingTimeEnd: this.mkTimeNow(stripping.end)
    }
    return new Promise((resolve, reject) => {
      this.httpClient.put(environment.API_ENDPOINT.apiOperacoesVazao+'/stripping-time', body)
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    })
  }

  async saveCowTime(id_operacao,id_operacaoLote,cowTime): Promise<any> {
    const user: any = await this.authService.getUserByLogin(this.authService);
    let body = {
      id_empresa: user.idEmpresa,
      id_usuario: user.idUsuario,
      id_operacao: id_operacao,
      id_lote: id_operacaoLote,
      strippingTimeBegin: this.mkTimeNow(cowTime.begin),
      strippingTimeEnd: this.mkTimeNow(cowTime.end)
    }
    return new Promise((resolve, reject) => {
      this.httpClient.put(environment.API_ENDPOINT.apiOperacoesVazao+'/cow-time', body)
        .toPromise()
        .then(res => resolve(res))
        .catch(err => reject(err));
    })
  }

  mkTimeNow(date){
    if(!date) return ''    
    const data = date.split('-')[0].trim().split('/');
    const hourMin = date.split('-')[1].trim();

    const [hours, minutes] = hourMin.split(':').map(Number);
    if(hours>23||minutes>59){
      this.alert.overflowIconErrorAlert({
        title: "Atenção",
        text: `${hourMin} não é um horário valido.`,
        okFunc: () =>{}
      })
    }
    
    return new Date(+data[2], +data[1]-1, +data[0], hours-3, minutes).toISOString();
  }
}

@Injectable()
export class OperacaoVazaoResponse {
  public id_empresa?: number = 0;
  public id_usuario?: number = 0;
  public id_operacaoVazao?: number = 0;
  public id_operacao: number = 0;
  public volumeTonelada: number = 0;
  public volumeBarril: number = 0;
  public volumeM3: number = 0;
  public data: string = "";
  public hora: string = "";
  public tipo: string = "";
}

@Injectable()
export class AddOperacaoVazao {
  public id_empresa: number = 0;
  public id_usuario: number = 0;
  public id_operacao: number = 0;
  public volumeTonelada: number = 0;
  public volumeBarril: number = 0;
  public volumeM3: number = 0;
  // public data: string = "";
  public hora: string = "";
  public tipo: string = "";
  public pressao: number = 0;
  public pressaoManifold: number = 0;
  public destinoPressao: number = 0;
  public destinoVolumeM3: number = 0;
  public id_loteSelecionado: number = 0;

}

@Injectable()
export class EditOperacaoVazao {
  public id_empresa?: number = 0;
  public id_usuario?: number = 0;
  public id_operacaoVazao?: number = 0;
  public id_operacao: number = 0;
  // public volumeTonelada: number = 0;
  // public volumeBarril: number = 0;
  public volumeM3: number = 0;
  public data: string = "";
  public hora: string = "";
  public tipo: string = "";
  public pressao: number = 0;
  public pressaoManifold: number = 0;
  public destinoPressao: number = 0;
  public destinoVolumeM3: number = 0;
  public id_lote: number = 0;
}